function initCardMedia() {
  document.querySelectorAll('.card-media').forEach((rootEl) => {
    const video = rootEl.querySelector('video');
    if (!video) return;

    const playVideo = () => {
      if (video.mediaControl) {
        video.mediaControl.playIfAble();
      } else if (video.autoplay && video.paused) {
        video.play().catch(() => {});
      }
    };

    video.addEventListener('canplay', playVideo);
    video.addEventListener('loadeddata', playVideo);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-card-media', () => {
      initCardMedia();
    });
  } else {
    initCardMedia();
  }
});
